import _typeof from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
var FormTypes = {
  normal: 'normal',
  input: 'input',
  inputNumber: 'inputNumber',
  checkbox: 'checkbox',
  select: 'select',
  date: 'date',
  datetime: 'datetime',
  upload: 'upload',
  slot: 'slot',
  hidden: 'hidden'
};
var VALIDATE_NO_PASSED = Symbol();
export { FormTypes, VALIDATE_NO_PASSED };
/**
 * 获取指定的 $refs 对象
 * 有时候可能会遇到组件未挂载到页面中的情况，导致无法获取 $refs 中的某个对象
 * 这个方法可以等待挂载完成之后再返回 $refs 的对象，避免报错
 * @author sunjianlei
 **/

export function getRefPromise(vm, name) {
  return new Promise(function (resolve) {
    (function next() {
      var ref = vm.$refs[name];

      if (ref) {
        resolve(ref);
      } else {
        setTimeout(function () {
          next();
        }, 10);
      }
    })();
  });
}
/**
 * 一次性验证主表单和所有的次表单
 * @param form 主表单 form 对象
 * @param cases 接收一个数组，每项都是一个JEditableTable实例
 * @returns {Promise<any>}
 * @author sunjianlei
 */

export function validateFormAndTables(form, cases) {
  if (!(form && typeof form.validateFields === 'function')) {
    throw "form \u53C2\u6570\u9700\u8981\u7684\u662F\u4E00\u4E2Aform\u5BF9\u8C61\uFF0C\u800C\u4F20\u5165\u7684\u5374\u662F".concat(_typeof(form));
  }

  var options = {};
  return new Promise(function (resolve, reject) {
    // 验证主表表单
    form.validateFields(function (err, values) {
      err ? reject({
        error: VALIDATE_NO_PASSED
      }) : resolve(values);
    });
  }).then(function (values) {
    Object.assign(options, {
      formValue: values
    }); // 验证所有子表的表单

    return validateTables(cases);
  }).then(function (all) {
    Object.assign(options, {
      tablesValue: all
    });
    return Promise.resolve(options);
  }).catch(function (error) {
    return Promise.reject(error);
  });
}
/**
 * 验证并获取一个或多个表格的所有值
 * @param cases 接收一个数组，每项都是一个JEditableTable实例
 * @author sunjianlei
 */

export function validateTables(cases) {
  if (!(cases instanceof Array)) {
    throw "'validateTables'\u51FD\u6570\u7684'cases'\u53C2\u6570\u9700\u8981\u7684\u662F\u4E00\u4E2A\u6570\u7EC4\uFF0C\u800C\u4F20\u5165\u7684\u5374\u662F".concat(_typeof(cases));
  }

  return new Promise(function (resolve, reject) {
    var tables = [];
    var index = 0;

    (function next() {
      var vm = cases[index];
      vm.getAll(true).then(function (all) {
        tables[index] = all; // 判断校验是否全部完成，完成返回成功，否则继续进行下一步校验

        if (++index === cases.length) {
          resolve(tables);
        } else next();
      }, function (error) {
        // 出现未验证通过的表单，不再进行下一步校验，直接返回失败并跳转到该表格
        if (error === VALIDATE_NO_PASSED) {
          reject({
            error: VALIDATE_NO_PASSED,
            index: index
          });
        }

        reject(error);
      });
    })();
  });
}